export default "__VITE_ASSET__DxsifkvU__"